/**
 * very simple Responsive image polyfill - handles default <f:responsiveImage /> implementation
 *
 * this implementation will render the following markup
 *
 * <noscript data-responsive-image="true">
 *   <picture>
 *     <source data-breakpoint="medium" width="640px" height="300px" src="path/to/medium-source.jpg" />
 *     <source width="480px" height="360px" src="path/to/small.jpg" />
 *     <img width="640px" height="300px" src="path/to/large.jpg" loading="lazy" />
 *   </picture>
 * </noscript>
 *
 * notice the data-breakpoint attribute, which we use to deal with named breakpoints that are streamlined
 * with out scss build. The named breakpoints can be defined in the window object before including this script
 *
 * this is very limited and needs some rules to be obeyed in order to work correctly:
 *
 * - only picture/source syntax supported
 * - sources need to be rendered in reverse mobile-first ordering (same behaviour as in regular picture elementes)
 */
(function (context, namedBreakpoints) {

    // @see https://ticket.pixelpoint.at/issues/33240
    // regular browsers do it with innerHTML but safari on iOS is a different story
    let accessor;
    const testNode = document.createElement('div');
    testNode.innerHTML = '<noscript><span></span></noscript>';
    const assertionNode = testNode.querySelector('noscript');
    if (assertionNode.innerHTML.indexOf('<') !== -1) {
        accessor = node => node.innerHTML;
        accessProperty = 'innerHTML';
    } else if (assertionNode.innerText.indexOf('<') !== -1) {
        accessor = node => node.innerText;
    } else if (assertionNode.textContent.indexOf('<') !== -1) {
        accessor = node => node.textContent;
    }
    /**
     * @param {HTMLElement} noscript
     * @return {?HTMLPictureElement}
     */
    function getPictureFromNoscriptElement(noscript) {
        return new DOMParser().parseFromString(accessor(noscript), 'text/html').querySelector('picture');
    }

    function processNodes(context) {
        Array.from(context.querySelectorAll('noscript[data-responsive-image]')).forEach(noscript => {
            const picture = getPictureFromNoscriptElement(noscript);
            Array.from(picture.querySelectorAll('[data-breakpoint]')).forEach(source => {
                const namedBreakpoint = namedBreakpoints[source.dataset.breakpoint];
                if (namedBreakpoint && namedBreakpoint.query !== "all") {
                    source.media = namedBreakpoint.query || `(min-width: ${source.dataset.breakpoint}px)`;
                }
            });
            noscript.parentNode.replaceChild(picture, noscript);
        });
    }

    const mutations = new MutationObserver(() => {
        processNodes(context);
    });
    processNodes(context);
    mutations.observe(context, {
        subtree: true,
        childList: true,
    });

})(document, window['namedBreakpoints'] ?? {});
